import {Component, ViewChild} from "@angular/core";
import {IContactService} from "../../../../domain/mailing/IContactService";
import {Contact} from "../../../../../../../server/src/base/entities/contact/Contact";
import {WaitingPopupComponent} from "../popup/waitingPopup/waitingPopup";
import {IRecaptchaService} from "../../../../infrastructure/Recaptcha/IRecaptchaService";

@Component({
    selector: 'contact',
    styleUrls: ['./contact.scss'],
    templateUrl: './contact.html'
})
export class ContactComponent {

    @ViewChild(WaitingPopupComponent) sendEmailPopupComponent:WaitingPopupComponent;

    private contactService:IContactService;
    private recaptchaService:IRecaptchaService;
    public contact:Contact;

    private emailError:boolean;
    private nameError:boolean;
    private messageError:boolean;

    public waitingMessage:string = "Envoi de votre message";
    public successMessage:string = "Votre message a bien été envoyé";
    public errorMessage:string = "Échec de l'envoi du message";

    constructor(contactService:IContactService, recaptchaService:IRecaptchaService){
        this.contactService = contactService;
        this.recaptchaService = recaptchaService;
    }

    ngOnInit(){
        this.contact = new Contact();
    }

    public submit(){
        if(this.IsValid(this.contact)){
            this.recaptchaService.GetToken('contact').then(token => {
                this.contact.token = token;
                this.sendEmailPopupComponent.Open();
                this.contactService.SendEmail(this.contact).then(() => {
                    this.contact.Reset();
                    this.sendEmailPopupComponent.Done(true);
                }).catch(() => {
                    this.sendEmailPopupComponent.Done(false);
                })
            }).catch(error => {
                console.error('Get token failed: ' + error);
            })
        }
    }

    public onEmailChanged(){
        if(this.emailError){
            this.emailError = false;
            document.getElementById("email").classList.remove("error");
        }
    }

    public onNameChanged(){
        if(this.nameError){
            this.nameError = false;
            document.getElementById("name").classList.remove("error");
        }
    }

    public onMessageChanged(){
        if(this.nameError){
            this.nameError = false;
            document.getElementById("message").classList.remove("error");
        }
    }

    private IsValid(contact:Contact){
        let valid:boolean = true;
        if(contact.name.length < 2){
            valid = false;
            this.nameError = true;
            document.getElementById("name").classList.add("error");
        }
        if(!this.IsEmailValid(contact.email)){
            valid = false;
            this.emailError = true;
            document.getElementById("email").classList.add("error");
        }
        if(contact.message.length < 1){
            valid = false;
            this.messageError = true;
        }
        return valid;
    }

    private IsEmailValid(email:string):boolean {
        let regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regex.test(email);
    }

}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/generic/contact/contact.ts